/*
 * @Description 组件 各分组人员
 * @Author 
 * @Date 
 */
/* HTML */
<template>
	<!-- index-sub-item start -->
	<div class="index-sub-item sub-item-groupusers" v-resize="elFormResize">
		<div class="sub-items-box-top"></div>
		
		<!-- sub-groupusers-box -->
		<div class="sub-items-box-center sub-groupusers-box">
			<div class="index-sub-title">各类绑定人员分析</div>
			<!-- sub-groupusers-content start -->
			<div class="sub-groupusers-content">
				
				<!-- groupusers-item-box start -->
				<div class="groupusers-item-box">
					<!-- 暂无数据 start -->
					<div v-if="$checkEmpty(dataList)" class="flex-center" style="color: #fff;font-size: 30px;height: 100%;width: 100%;">暂无数据</div>
					<!-- chart -->
					<div v-show="!$checkEmpty(dataList)" id="groupUserCount"></div>
					<!-- 工时统计 -->
				</div>
				<!-- groupusers-item-box end -->
				
				<!-- user-time-box start -->
				<ul class="user-time-box">
					<li><i class="list-icon-bg bg-color-yellow"></i><span>现场施工总工时<b class="user-time-val">{{!$checkEmpty(totalTime[7]) && !$checkEmpty(totalTime[7].number) ? totalTime[7].number : '----'}}</b>人时</span></li>
					<li><i class="list-icon-bg bg-color-red"></i><span>带班领导总工时<b class="user-time-val">{{!$checkEmpty(totalTime[8]) && !$checkEmpty(totalTime[8].number) ? totalTime[8].number : '----'}}</b>人时</span></li>
				</ul>
				<!-- user-time-box end -->
				
			</div>
			<!-- sub-groupusers-content end -->
		</div>
		<!-- sub-groupusers-box -->
		
		<div class="sub-items-box-bottom"></div>
	</div>
	<!-- index-sub-item end -->
</template>

/* JS */
<script>
	// 交互 接口
	import ApiUser from '@/request/api-user';
	// API 进场
	import ApiApproach from '@/request/api-approach';
	
	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
        name: "IndGroupUser",
        
        /**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
        components: {
        	
        },// components
        
        /**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
        props: {
        	
        },// props
        
        /**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				// 数据列表
				dataList: [
//					{name: '施工1组', val: 10},
//					{name: '施工2组', val: 8},
//					{name: '施工3组', val: 11},
//					{name: '管理1组', val: 5},
//					{name: '管理2组', val: 6},
//					{name: '管理3组', val: 3},
				],
				
				// 总工时
				totalTime: {},
				
				// 定时器
				timer_checkDataInt: null,// 检索数据
				timer_initCharts: null,// 初始化 图表
			}
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			// 开启订阅消息
			this.startSubscribes();
			
			// 数据查询
			this.searchData();
			// 查询 总工时
			this.searchTotalTime();
		},// mounted
		
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			// 取消订阅消息
			this.endSubscribes();
			// 关闭 timer
        	this.endTimers();
		},// beforeDestroy
		
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {
			
		},// destroyed
		
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			/**
        	 * @Des 关闭 timer
        	 * @Auth
        	 * @Date
        	 */
        	endTimers() {
				// 清除计时器
				if (!this.$checkEmpty(this.timer_checkDataInt)) {
					clearInterval(this.timer_checkDataInt);
					this.timer_checkDataInt = null;
				}
				// 清除计时器
				if (!this.$checkEmpty(this.timer_initCharts)) {
					clearTimeout(this.timer_initCharts);
					this.timer_initCharts = null;
				}
        	},
			/**
			 * @Des dom 尺寸更改
			 * @Auth
			 * @Date 
			 */
			elFormResize(data) {
				// 清除定时器
				if (!this.$checkEmpty(this.timer_checkDataInt)) {
					// 清除定时器
					clearInterval(this.timer_checkDataInt);
				}
				
				if (!this.$checkEmpty(this.dataList)) {
					this.$nextTick(() => {
						// 初始化 charts
						this.initCharts();
					});
				} else {
					// 定时器
					this.timer_checkDataInt = setInterval(() => {
						if (!this.$checkEmpty(this.dataList)) {
							// 清除定时器
							clearInterval(this.timer_checkDataInt);
							this.$nextTick(() => {
								// 初始化 charts
								this.initCharts();
							});
						}
					}, 200);
				}
			},
			
			//========================== 订阅消息 start ==========================
			/**
			 * @Des 开启订阅消息
			 * @Auth
			 * @Date
			 */
			startSubscribes() {
				// 订阅消息 详情页
				this.sub_dataChange = this.$pubsub.subscribe('UserChange', (name, data) => {
					// 数据查询
					this.searchData();
					// 查询 总工时
					this.searchTotalTime();
				});
				// 订阅消息 总工时
				this.sub_totalTimeChange = this.$pubsub.subscribe('TotalTimeChange', (name, data) => {
					// 查询 总工时
					this.searchTotalTime();
				});
			},
			/**
			 * @Des 取消订阅消息
			 * @Auth
			 * @Date
			 */
			endSubscribes() {
				//取消订阅 详情页
				this.$pubsub.unsubscribe(this.sub_dataChange);
				//取消订阅 总工时
				this.$pubsub.unsubscribe(this.sub_totalTimeChange);
			},
			
			//========================== 订阅消息 end ==========================
			
			/**
			 * @Des 点击条目btn
			 * @Auth
			 * @Date
			 */
			handleItemBtn(row) {
				// 参数
				let filter = {};
				// 点击条目
				this.handleDetailBtn('GroupUser', '各分组人员', filter);
			},
			
			/**
			 * @Des 点击条目
			 * @Auth
			 * @Date
			 */
			handleDetailBtn(detailSubRef, detailSubName, detailFilters) {
				// 发布消息 详情页
				this.$pubsub.publish('handleDetail', {showDetailFlag: true, detailSubRef: detailSubRef, detailSubName: detailSubName, detailFilters: detailFilters});
			},
			
			/**
			 * @Des 初始化 charts
			 * @Auth
			 * @Date 
			 */
			initCharts() {
				// 清除计时器
				if (!this.$checkEmpty(this.timer_initCharts)) {
					clearTimeout(this.timer_initCharts);
					this.timer_initCharts = null;
				}
				
				// dispose
				if (this.myChart) this.myChart.dispose();
				// myChart 各组人员的数量
				this.myChart = this.$echarts.init(document.getElementById('groupUserCount'));
				// 初始化 chart 各组人员的数量
				this.initChart();
				
				this.timer_initCharts = setTimeout(() => {
					// 初始化 charts
					this.initCharts();
				}, 10*1000);
			},
			
			/**
			 * @Des 初始化 chart 各组人员数量 饼图
			 * @Auth
			 * @Date 2021/10/8
			 */
			initChart() {
				
				// 数据重组
				let dataList = Object.assign([], this.dataList);
				
				// 遍历 提取数据
				dataList.forEach((row, index) => {
					row.value = !this.$checkEmpty(row.val) ? row.val : 0;
				});
				
				let THIS = this;
				this.option = {
					darkMode: false,
					textStyle: {
						/*color: '#B9B8CE'*/
						color: '#fff'
					},
					title: {
						text: '',
						subtext: '',
						left: 'center',
						textStyle: {
							color: '#fff',
							fontSize: 18,
							fontWeight: 'bold'
						},
						subtextStyle: {
							color: '#fff',
							fontSize: 12
						}
					},
					tooltip: {
						trigger: 'item',
						textStyle: {
							align: 'justify'
						}
					},
					legend: {
						//orient: 'vertical',
						left: 'left',
						textStyle: {
							color: '#fff',
							lineHeight: 0,
							height: 0,
							rich:{
		                        a:{
		                            fontSize:14,
		                            align:'left',
		                            padding:[0,0,0,0],
		                            verticalAlign: 'middle'
		                        },
		                        b:{
		                            fontSize:18,
		                        	lineHeight: 40,
		                        	
		                            align:'center',
		                            padding:[10,0,0,0],
		                            fontWeight: 'bold'
		                        }
							}
						},
						icon:'circle',
						formatter: function (name) {
							let data = THIS.option.series[0].data
							// console.log(data, 'data')
							let total = 0
							let tarValue
							for (let i = 0; i < data.length; i++) {
								total += data[i].value
								if (data[i].name == name) {
									tarValue = data[i].value
								}
							};
							let v = tarValue + '人';
							//计算出百分比
							let p = Math.round((tarValue / total) * 100) + '%';
							
							return  '{a|'+ name +' }\n{b|'+ v +'}';
							//return `${name}  \n ${'<b>'+v+'</b>'}`;
							//name是名称，v是数值
						},
					},
					color: ['#ffcc43', '#ff4343', '#4375ff', '#4185f0', '#feb10d', '#08d5fb', '#05c091', '#58d9f9', '#4992ff', '#7cffb2', '#ff8a45', '#8d48e3', '#fddd60', '#dd79ff', '#ff6e76', ],
					series: [
						{
							name: '人员数量',
							type: 'pie',
							//radius: '60%',
							radius: ['50%', '60%'],
							data: dataList,
							emphasis: {
								itemStyle: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.8)'
								}
							},
							label: {
								show: false
							},
							labelLine: {
								show: false
							}
						}
					]
				};
				// set option
				this.myChart.setOption(this.option);
			},
			
			/**
			 * @Des 初始化 chart 各组人员的数量
			 * @Auth
			 * @Date 
			 */
			initChart_bar() {
				// 数据重组
				let dataList = Object.assign([], this.dataList);
				
				let nameList = [];
				let numList = [];
				// 遍历 提取数据
				dataList.forEach((row, index) => {
					nameList.push(row.name);
					numList.push(row.val);
				});
				
				this.option = {
					darkMode: true,
					textStyle: {
						color: '#fff'
					},
					title: {
						text: '',
						subtext: '',
						textStyle: {
							color: '#B9B8CE',
							fontSize: 18,
							fontWeight: 'bold'
						},
						subtextStyle: {
							color: '#B9B8CE',
							fontSize: 12
						},
						left: 'center',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						},
						textStyle: {
							align: 'justify'
						}
					},
					legend: {
						show: false,
						left: 'right',
						textStyle: {
							color: '#B9B8CE'
						}
					},
					grid: {
						top: '10%',
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					yAxis: {
						type: 'value',
						boundaryGap: [0, 0.01],
						minInterval: 1
					},
					xAxis: {
						type: 'category',
						axisLabel: {
							interval:0, //强制显示文字
						},
						data: nameList
					},
					series: [
						{
							name: '数量',
							type: 'bar',
							label: {
								show: true,
								formatter: '{c}',
								color: '#fff'
							},
							itemStyle: {
								color: function (param) {
									let colorList = [
										'#91cc75', '#48bb11', '#48aa19', '#51dd0f', '#6fdb3b', '#60c230',
										'#98e274', '#8acc6a', '#74ac59', '#55e50f', '#4ac90c', '#42b10c',
									];
									return colorList[param.dataIndex] || 'red';
								}
							},
							data: numList
						}
					]
				};
				
				// set option
				this.myChart.setOption(this.option);
			},
			
			//========================== 数据查询 查询 start ==========================
			/**
			 * @Des 查询 数据查询
			 * @Auth 
			 * @Date 
			 */
			searchData(){
				this.$request.postJsonRequest(ApiUser.searchNumber,{
					projectId: this.$store.state.currentProjectId,
					type: 1,
				}).then(result => {
					// 成功
					if (result.code == 0 && !this.$checkEmpty(result.data)) {
						
						if (!this.$checkEmpty(result.data)) {
							let dataList = [];
							let data = Object.assign([], result.data);
							
							// 遍历
							data.forEach((row, index) => {
								dataList.push({name: row.typeName, val: (parseInt(row.userNumber) > 0 ? parseInt(row.userNumber) : 0) });
							});
							
							// 数据列表
							this.dataList = Object.assign([], dataList);
						} else {
							// 数据列表
							this.dataList = [];
						}
						
						this.$nextTick(() => {
							// 初始化 charts
							this.initCharts();
						});
					}
				}).catch(error => {
					console.error('查询各组人员数据异常', ApiUser.searchNumber, error);
				})
			},// searchData
			/**
			 * @Des 查询 总工时
			 * @Auth 
			 * @Date 
			 */
			searchTotalTime() {
				// 总工时
				this.totalTime = Object.assign({}, {});
				this.$request.postJsonRequest(ApiApproach.searchTotalTimeApi,{
					projectId: this.$store.state.currentProjectId,
				}).then(result => {
					let totalTime = {};
					let rows = Object.assign([], result.data);
					rows.forEach((row, index) => {
						// 空值 跳过
						if (this.$checkEmpty(row) || this.$checkEmpty(row.typeId)) return true;
						totalTime[row.typeId] = Object.assign({}, row);
					});
					// 总工时
					this.totalTime = Object.assign({}, totalTime);
				}).catch(error => {
					console.error('查询总工时数据异常', ApiApproach.searchTotalTimeApi, error);
				})
			},// searchTotalTime
			//========================== 数据查询 查询 end ==========================
			
		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
    }// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_index/IndexItems/IndGroupUser.vue